<template>
  <v-dialog v-model="dialog" scrollable max-width="1100px" persistent>
    <v-form ref="form">
      <v-card>
        <v-toolbar color="white" fixed>
          <h3>{{ $i18n.t(label) }}</h3>
        </v-toolbar>
        <v-card-text>
          <v-container dense v-for="(config, index) in invConfigList" :key="index + 'taxConfig'">
            <v-row>
              <v-col cols="12" md="2">
                <z-entity-select
                  class="purple-input"
                  v-model="config.vendorEntity_id"
                  :label="$i18n.t('Serving Entity')"
                  corp="self"
                />
              </v-col>
              <v-col cols="12" md="2">
                <z-client-select class="purple-input" v-model="config.client_id" disabled />
              </v-col>
              <v-col cols="12" md="2">
                <z-entity-select
                  disabled
                  class="purple-input"
                  v-model="config.clientEntity_id"
                  :corp="config.client_id"
                  :label="$i18n.t('Client Entity')"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="config.taxSlab_id"
                  :label="$i18n.t('Tax Slab')"
                  :items="taxSlabList"
                  item-text="name"
                  item-value="_id"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-btn
                  color="grey darken-1"
                  :href="'/invoiceconfig/' + config._id"
                  v-if="config._id"
                  target="_blank"
                >Edit</v-btn>
                <v-btn color="blue darken-1" @click="save(config)" :loading="loading">Save</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="closeDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import common from "@/store/common/module/common";
import { commonMixin } from "@/mixins/common";
import corpService from "@/store/common/module/CorpService";
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";

@Component({
  name: "InvoiceConfigSetup",
  props: {
    client_id: {
      default: null,
    },
    // vendorEntity_id: {
    //   default: null,
    // },
    showDialog: {
      default: false,
    },
    label: {
      default: "Invoice Configuration",
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class InvoiceConfigSetup extends (Vue, Themeable) {
  invConfigList = [];
  dialog = false;
  taxSlabList = [];

  get loading() {
    return common.loading;
  }

  async save(config) {
    try {
      common.setLoading(true);
      const response = await doPost("/api/invoiceconfig/save", config);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      this.fetchInvConfigs(this.client_id);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async fetchInvConfigs(corp_id) {
    common.setLoading(true);
    try {
      const url = `/api/invoiceconfig/client/${corp_id}/all`;
      this.invConfigList = await doGet(url);
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
    }
  }

  closeDialog() {
    this.dialog = false;
    this.$emit("closeInvConfig", false);
  }

  @Watch("showDialog")
  onChangeDialog(newVal) {
    if (!this.client_id) {
      common.setError("Please provide client.");
      this.closeDialog();
      return;
    }
    // if (!this.vendorEntity_id) {
    //   common.setError("Please provide Entity.");
    //   this.closeDialog();
    //   return;
    // }
    this.fetchInvConfigs(this.client_id);
    this.dialog = true;
  }

  async mounted() {
    this.taxSlabList = await doGet("/api/taxslab/all");
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 60px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
